import styled from '@emotion/styled';
import { IChatRoom } from 'domain/entities/ChatRoom/ChatRoom';
import { UserIcon } from 'ui/components/elements/UserIcon/UserIcon';
import AttentionIcon from 'ui/images/attention.svg';
import dayjs from 'dayjs';

const Wrapper = styled.div<{ selected: boolean; isPremium: boolean }>`
    display: flex;
    flex-direction: column;
    gap: 10px;
    border-radius: 4px;
    padding: 10px;
    cursor: pointer;
    box-shadow: 2px 2px 4px 0px #0000001a;
    position: relative;
    border: ${({ selected }) => (selected ? '1px solid var(--main-color-blue)' : 'none')};
    background: ${({ isPremium }) => (isPremium ? 'linear-gradient(to right, #fff8e1, #ffeb99)' : 'var(--white)')};
`;

const AgentNameContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    font-weight: var(--font-bold);
`;

const DateContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: var(--font-small);
`;

const MessageContainer = styled.div`
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
`;

const Label = styled.div`
    font-size: var(--font-small);
    color: var(--white);
    white-space: nowrap;
    background: linear-gradient(45deg, #daa520, #b8860b);
    padding: 5px 8px;
    border-radius: 10px;
    width: fit-content;
    font-weight: var(--font-bold);
`;

const NoMeetingDateLabel = styled.div`
    font-size: var(--font-small);
    color: var(--white);
    white-space: nowrap;
    background: var(--green);
    padding: 5px 8px;
    border-radius: 10px;
    width: fit-content;
    font-weight: var(--font-bold);
`;

const Labels = styled.div`
    display: flex;
    gap: 10px;
`;

const NewLabel = styled.div`
    position: absolute;
    bottom: 8px;
    right: 8px;
    font-size: var(--font-small);
    color: var(--white);
    background-color: red;
    padding: 3px 6px;
    border-radius: 10px;
    font-weight: var(--font-bold);
`;

const DateConfirmation = styled.div`
    font-size: var(--font-small);
    color: red;
    font-weight: var(--font-bold);
    display: flex;
    align-items: center;
    gap: 2px;
    margin-left: 5px;

    img {
        width: 12px;
        height: 12px;
    }
`;

export const ChatRoomItem: React.FC<{
    chatRoom: IChatRoom;
    selected: boolean;
    unread: boolean;
    onClick: () => void;
}> = ({ chatRoom, selected, unread, onClick }) => {
    const noMessage = chatRoom.last_message_sent_at === null;
    const meetingDateConfirmation =
        chatRoom.match?.meeting_date_confirmation?.tentative_meeting_date &&
        chatRoom.match?.meeting_date_confirmation?.requesting_agent_user;

    return (
        <Wrapper selected={selected} isPremium={!!chatRoom.match?.premium_offer} onClick={onClick}>
            <Labels>
                {chatRoom.match?.premium_offer && <Label>プレミアムオファー</Label>}
                {!chatRoom.match?.meeting_date && <NoMeetingDateLabel>面談日未設定</NoMeetingDateLabel>}
            </Labels>
            {meetingDateConfirmation && (
                <DateConfirmation>
                    <img src={AttentionIcon} alt="アイコン" />
                    面談日を承諾してください
                </DateConfirmation>
            )}
            <AgentNameContainer>
                <UserIcon size={30} src={chatRoom.match.agent.icon_image} />
                <span>{chatRoom.match.agent.name}</span>
            </AgentNameContainer>

            <DateContainer>
                {noMessage ? (
                    <span>マッチング日：{dayjs(chatRoom.match.date_matched).format('YYYY/MM/DD')}</span>
                ) : (
                    <span>{dayjs(chatRoom.last_message_sent_at).format('YYYY/MM/DD HH:mm')}</span>
                )}
            </DateContainer>
            <MessageContainer>
                {noMessage ? (
                    <span>{chatRoom.match.message_from_brokerage}</span>
                ) : (
                    <span>{chatRoom.last_message_text}</span>
                )}
            </MessageContainer>
            {unread && <NewLabel>未読</NewLabel>}
        </Wrapper>
    );
};
